// src/native/day-counter-bridge.ts
import { registerPlugin } from '@capacitor/core';

export type NativeDayCounter = {
  ensureInstallTs(): Promise<void>;
  reset(): Promise<void>;
  reloadDayCounterWidget(): Promise<void>;
  reloadAllWidgets(): Promise<void>;
};

export const DayCounter = registerPlugin<NativeDayCounter>('DayCounter');